<template>
    <v-footer app inset>
        <v-container>
            <v-row>
                <template v-if="$slots.actions">
                    <slot name="actions" />
                </template>
                <template v-else>
                    <v-col v-if="showSave">
                        <v-btn color="primary" block @click="$emit('save')" :loading="loading" v-if="$can(action, esv)">
                            <v-icon left>save</v-icon>
                            <span>Save</span>
                        </v-btn>
                    </v-col>
                    <v-col v-if="showStartApproval && $can('StartApproval', esv)">
                        <v-btn color="primary" block @click="$emit('start-approval')" :loading="loading">
                            <v-icon left>mdi-check-decagram</v-icon>
                            <span>Start approval</span>
                        </v-btn>
                    </v-col>
                    <v-col v-if="showCancel">
                        <v-btn outlined block  @click="$emit('cancel')">
                            <v-icon left>{{ cancelIcon }}</v-icon>
                            <span>{{ cancelText }}</span>
                        </v-btn>
                    </v-col>
                </template>
            </v-row>
        </v-container>
    </v-footer>
</template>

<script>
export default {
    name: 'TabFooter',
    props: {
        esv: {
            type: Object,
            required: true
        },
        action: {
            type: String,
            default: 'Edit'
        },
        loading: Boolean,
        showSave: {
            type: Boolean,
            default: true
        },
        showStartApproval: {
            type: Boolean,
            default: true
        },
        showCancel: {
            type: Boolean,
            default: true
        },
        cancelText: {
            type: String,
            default: 'Cancel'
        },
        cancelIcon: {
            type: String,
            default: 'cancel'
        }
    },
    computed: {
    },
    methods: {
        
    }
}
</script>